import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { SharedNewModule } from 'src/app/shared-new/shared-new.module';

import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { AdditionalXraysComponent } from './additional-xrays/additional-xrays.component';
import { StudyFileNotificationModalComponent } from './study-file-notification-modal/study-file-notification-modal.component';
import { EditStudyComponent } from './edit-study/edit-study.component';
import { ImageModalComponent } from './image-modal/image-modal.component';
import { MatchedXraysComponent } from './matched-xrays/matched-xrays.component';
import { StudyPreviewModalComponent } from './study-preview-modal/study-preview-modal.component';
import { UploadFileComponent } from './upload-file/upload-file.component';
import { XrayGridComponent } from './xray-grid/xray-grid.component';
import { XrayItemComponent } from './xray-item/xray-item.component';
import { XrayModalComponent } from './xray-modal/xray-modal.component';

import { ApprovedStudyComponent } from './approved-study/approved-study.component';
import { ApprovedTableComponent } from       './approved-study/approved-table/approved-table.component';
import { DiscloseClientPopupComponent } from './approved-study/disclose-client-popup/disclose-client-popup.component';
import { CategoryModalComponent } from './category-modal/category-modal.component';
import { ReviewStudyComponent } from './review-study/review-study.component';
import { ReviewTableComponent } from './review-study/review-table/review-table.component';
import { AssetTableComponent } from './upload-study/asset-table/asset-table.component';
import { MissingXraysComponent } from './upload-study/missing-xrays/missing-xrays.component';
import { MultipleXraysComponent } from './upload-study/multiple-xrays/multiple-xrays.component';
import { ScopeReportComponent } from './upload-study/scope-report/scope-report.component';
import { UnmatchedXraysComponent } from './upload-study/unmatched-xrays/unmatched-xrays.component';
import { UploadStudyComponent } from './upload-study/upload-study.component';
import { StudyDocsListTableComponent } from './study-docs-list-table/study-docs-list-table.component';
import { EditClinicalStudyComponent } from '../edit-clinical-study.component';
import { RouterModule } from '@angular/router';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CategorizedXraysComponent } from './categorized-xrays/categorized-xrays.component';
import { ClinicalStudySumbissionAcknowledgmentsPopupComponent } from './clinical-study-sumbission-acknowledgments-popup/clinical-study-sumbission-acknowledgments-popup.component';
import { SubmissionValidationPopupComponent } from './submission-validation-popup/submission-validation-popup.component';
import { NotificationTemplateModule } from '../../../shared/notification-template/notification-template.module';

@NgModule({
  declarations: [
    MatchedXraysComponent,
    StudyFileNotificationModalComponent,
    CategoryModalComponent,
    XrayModalComponent,

    StudyPreviewModalComponent,
    XrayItemComponent,
    XrayGridComponent,
    AdditionalXraysComponent,
    UploadFileComponent,
    ImageModalComponent,
    EditStudyComponent,

    UploadStudyComponent,
    ScopeReportComponent,
    UnmatchedXraysComponent,
    MultipleXraysComponent,
    AssetTableComponent,

    ReviewStudyComponent,
    ReviewTableComponent,

    MissingXraysComponent,
    UploadStudyComponent,
    ApprovedStudyComponent,
    ApprovedTableComponent,
    StudyDocsListTableComponent,
    EditClinicalStudyComponent,
    CategorizedXraysComponent,
    DiscloseClientPopupComponent,
    //ClinicalStudySumbissionConfirmationPopupComponent
    ClinicalStudySumbissionAcknowledgmentsPopupComponent,
    SubmissionValidationPopupComponent

  ],
  imports: [
    CommonModule,
    SharedNewModule,
    FormsModule,
    ReactiveFormsModule,
    MatTableModule,
    MatCheckboxModule,
    AutocompleteLibModule,
    RouterModule,
    NotificationTemplateModule
  ],
  exports: [
    MatchedXraysComponent,
    CategorizedXraysComponent,
    StudyFileNotificationModalComponent,
    CategoryModalComponent,
    XrayModalComponent,
    StudyPreviewModalComponent,
    XrayItemComponent,
    XrayGridComponent,
    AdditionalXraysComponent,
    UploadFileComponent,
    ImageModalComponent,
    EditStudyComponent,

    UploadStudyComponent,
    ScopeReportComponent,
    UnmatchedXraysComponent,
    MultipleXraysComponent,
    AssetTableComponent,

    ReviewStudyComponent,
    ReviewTableComponent,

    MissingXraysComponent,
    UploadStudyComponent,
    ApprovedStudyComponent,
    ApprovedTableComponent,
    EditClinicalStudyComponent,
    DiscloseClientPopupComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class StudiesComponentModule {}
